export default __webpack_public_path__ + "static/media/salute.81d4a43d.png";